import type { JSX } from 'react';

import { Box } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import type { PreviewEmailContentSubjectProps } from '../../../../../../types';

export function PreviewEmailContentSubject({ text }: PreviewEmailContentSubjectProps): JSX.Element {
	return (
		<Box px={16} mb={[8, 16]}>
			<Text as="h4" size="huge" sx={{ lineHeight: 1.4, fontFamily: 'Helvetica Neue' }} fontWeight="bold" m={0}>
				{text}
			</Text>
		</Box>
	);
}
